module.exports = __webpack_public_path__ + "img/ezra-lee.1cf62c38.png";